import { SxStyleProp } from 'theme-ui';

export const BaseContainer: SxStyleProp = {
  padding: ['94px 20px', '94px 0'],
  '&.partners': {
    padding: 0,
  },
  '&.partnerstechnology, &.partnersmssp': {
    padding: ['64px 20px 0', '94px 0'],
  },
};

export const RestrictedContainer: SxStyleProp = {
  maxWidth: '945px !important',
};

export const ContainerWithCenteredText: SxStyleProp = {
  textAlign: 'center',
};

export const ContainerWithLightText: SxStyleProp = {
  color: '#fff',
};

export const Cta: SxStyleProp = {
  m: '70px auto 0 auto',
};

export const Subtitle: SxStyleProp = {
  marginTop: '24px',
};
